import { render, staticRenderFns } from "./CompanyManagementCampaign.vue?vue&type=template&id=210ed484"
import script from "./CompanyManagementCampaign.vue?vue&type=script&lang=js"
export * from "./CompanyManagementCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports